export default {
	LOGO_ALT: 'AustralianSuper logo',
};
